import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import s from './ConstituencyWrapper.scss';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2';
import {
  filterSearchSortData,
  loadYearWiseCandidatesData,
} from '../../../routes/newslisting/redux';
import LoaderSpinner from '../LoaderSpinner';
import CandidateCard from '../../../components/ElectionV2/common/CandidateCard';
import PaginationWidgetWithoutLink from '../../../routes/newslisting/components/common/PaginationWidget/PaginationWidgetWithoutLink';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import SortSelect from '../SortSelect';
import InputSearch from '../InputSearch';
import Link from '../../../components/Link/Link';
import { createSlug } from '../../../utils/common';

class ConstituencyCandidateWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.selectedConst =
      props.force &&
      Array.isArray(props.loksabhaStates) &&
      props.loksabhaStates.length > 0 &&
      props.loksabhaStates[0]?.name
        ? Object.values(
            props.stateConstMapping[props.loksabhaStates[0].name],
          ).flat()
        : Object.values(props.stateConstMapping).flat();
    this.selectedConst = [
      {
        name: 'Constituencies',
        seoname: '',
      },
      ...this.selectedConst,
    ];
    this.status = [
      { name: 'Results', seoname: 0 },
      { name: 'Won', seoname: 3 },
      { name: 'Lost', seoname: 4 },
    ];
    this.state = {
      searchTerm: '',
      sort: { alpha: 1, key: props.loksabha ? 'seonm' : 'cn' },
      sortSelection: false,
      searches:
        props.force &&
        Array.isArray(props.loksabhaStates) &&
        props.loksabhaStates.length > 0
          ? { sn: props.loksabhaStates[0].seoname }
          : {},
      currentPage: 1,
      currentState:
        props.force &&
        Array.isArray(props.loksabhaStates) &&
        props.loksabhaStates.length > 0
          ? props.loksabhaStates[0]
          : {
              name: 'Select State',
              seoname: '',
            },
      currentConst: {
        name: 'Constituencies',
        seoname: '',
      },
      currentStatus: {
        name: 'Results',
        seoname: 0,
      },
      selectedConst: this.selectedConst,
    };

    try {
      const { electionData } = props?.sectionItem?.items || {};
      const latestData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData)
          .filter(
            e =>
              this.props.starCandidatePage
                ? e.starCandidatesUrl
                : e.candidatesUrl,
          )
          .sort((a, b) => b.year - a.year);
      if (latestData && Array.isArray(latestData) && latestData.length) {
        const {
          live,
          source,
          starCandidateLink = '',
          candidateLinking = false,
        } = latestData[0];
        this.state.live = live;
        this.state.source = source;
        this.state.starCandidateLink = starCandidateLink;
        this.state.candidateLinking = candidateLinking;
        this.state.selectedYear = Object.values(electionData).sort(
          (a, b) => b.year - a.year,
        )[0].year;
      }
    } catch (error) {
      //
    }
    this.sortMapping = [{ method: 'alpha', text: 'Alphabet', order: 1 }];
    this.DEBOUNCE_DELAY = 500;
  }

  componentDidMount() {
    const { electionData } = this.props.sectionItem.items;
    if (electionData) {
      const latestData =
        Object.values(electionData) &&
        Array.isArray(Object.values(electionData)) &&
        Object.values(electionData)
          .filter(
            e =>
              this.props.starCandidatePage
                ? e.starCandidatesUrl
                : e.candidatesUrl,
          )
          .sort((a, b) => b.year - a.year);
      if (latestData && Array.isArray(latestData) && latestData.length) {
        const data = latestData[0];
        if (data.live) {
          setInterval(() => {
            if (
              (data.starCandidatesUrl || data.candidatesUrl) &&
              data.year &&
              data.year === this.state.selectedYear
            ) {
              this.props.loadAjaxElectionData(
                this.props.starCandidatePage
                  ? data.starCandidatesUrl
                  : data.candidatesUrl,
                data,
                this.state.searches,
                this.state.sort,
                false,
                this.props.force,
                this.props.starCandidatePage,
              );
            }
          }, 30 * 1000);
        }
      }
    }
  }

  debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  debouncedSearch = this.debounce(searches => {
    this.props.filterData(searches, this.state.sort, true);
  }, this.DEBOUNCE_DELAY);

  onTabsChange = params => {
    const {
      candidatesUrl,
      starCandidatesUrl,
      year,
      live,
      source,
      starCandidateLink,
      candidateLinking,
    } = params.clickedItem;
    const { electionData } = this.props.sectionItem.items;
    this.setState({
      selectedYear: year,
      live,
      source,
      starCandidateLink,
      candidateLinking,
    });
    this.props.loadAjaxElectionData(
      this.props.starCandidatePage ? starCandidatesUrl : candidatesUrl,
      electionData[year],
      this.state.searches,
      this.state.sort,
      true,
      this.props.force,
      this.props.starCandidatePage,
    );
  };

  handleSearchChange = e => {
    const term = e.target.value;
    this.setState(
      {
        searches: {
          ...this.state.searches,
          'cn#sn#cns_name#an': term,
        },
        currentPage: 1,
      },
      () => {
        this.debouncedSearch(this.state.searches);
      },
    );
  };

  handleStateChange = ({ seoname, name }) => {
    this.setState(
      {
        currentState: { name, seoname },
        currentConst: this.selectedConst[0],
        sortSelection: false,
        currentPage: 1,
        searches: { ...this.state.searches, sn: seoname, cns_name: '' },
        selectedConst: seoname
          ? [this.selectedConst[0], ...this.props.stateConstMapping[name]]
          : this.selectedConst,
      },
      () => {
        this.props.filterData(this.state.searches, this.state.sort, true);
      },
    );
  };

  handleConstChange = ({ seoname, name }) => {
    this.setState(
      {
        currentConst: { name, seoname },
        sortSelection: false,
        currentPage: 1,
        searches: { ...this.state.searches, cns_name: seoname },
      },
      () => {
        this.props.filterData(this.state.searches, this.state.sort, true);
      },
    );
  };

  handleWonLostChange = ({ seoname, name }) => {
    this.setState(
      {
        currentStatus: { name, seoname },
        sortSelection: false,
        currentPage: 1,
        searches: { ...this.state.searches, cs: seoname },
      },
      () => {
        this.props.filterData(this.state.searches, this.state.sort, true);
      },
    );
  };

  handleSortSelection = () => {
    this.setState({ sortSelection: !this.state.sortSelection });
  };

  reverseSort = e => {
    e.stopPropagation();
    const { alpha = null, margin = null } = this.state.sort;
    const sort = {};
    if (alpha) {
      sort.alpha = this.state.sort.alpha * -1;
    }
    if (margin) {
      sort.margin = this.state.sort.margin * -1;
    }
    this.setState({ sort });
    this.props.filterConstituencyData(
      this.state.searchTerm,
      sort,
      this.state.currentState.seoname,
    );
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page,
    });
    if (this.paginationRef.current) {
      this.paginationRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  render() {
    const settings = {
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      infinite: false,
    };
    this.paginationRef = React.createRef();
    const { electionData } = this.props.sectionItem.items;
    const itemsPerPage = this.props.isWapView ? 50 : 102;
    const startIndex = (this.state.currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const itemsToShow =
      this.props.filteredData &&
      Array.isArray(this.props.filteredData) &&
      this.props.filteredData.length > 0 &&
      this.props.filteredData.slice(startIndex, endIndex);
    return (
      <div className={`${s.constituencyWrap}`}>
        {this.props.sectionItem &&
          this.props.sectionItem.note &&
          this.state.live && (
            <p className={s.noteText}>{this.props.sectionItem.note}</p>
          )}
        <div className={`${s.tabWrap} ${s.candiTab}`} ref={this.paginationRef}>
          <Listingheader
            headingname={`${
              this.props.starCandidatePage ||
              (this.props.starCandidatesData &&
                Array.isArray(this.props.starCandidatesData) &&
                this.props.starCandidatesData.length > 0)
                ? 'Star Candidates'
                : 'All Candidates'
            }`}
            headingLink={
              !this.props.starCandidatePage ? this.state.starCandidateLink : ''
            }
          />
          <div className={s.tabs}>
            <span>Results : </span>
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(
                  ed =>
                    this.props.starCandidatePage
                      ? ed.starCandidatesUrl
                      : ed.candidatesUrl,
                )
                .sort((a, b) => b.year - a.year)
                .map(ed => ({
                  ...ed,
                  url: this.props.starCandidatePage
                    ? ed.starCandidatesUrl
                    : ed.candidatesUrl,
                  link: this.props.starCandidatePage
                    ? ed.starCandidatesUrl
                    : ed.candidatesUrl,
                }))}
              onChangeCallback={this.onTabsChange}
              // loading={this.state.loading}
            />
          </div>
        </div>

        {this.props.dataLoading && <LoaderSpinner />}
        <div className={s.candidateWrap}>
          {!this.props.isWapView &&
            !this.props.starCandidatePage &&
            this.props.starCandidatesData &&
            Array.isArray(this.props.starCandidatesData) &&
            this.props.starCandidatesData.length > 0 && (
              <div className="slick_UI smallArrow smallArrowBlack">
                <Slider {...settings}>
                  {this.props.starCandidatesData.map(
                    (item, idx) =>
                      this.state.candidateLinking &&
                      item?.sn &&
                      item?.seonm &&
                      item?.cns_name &&
                      item.seonm !== 'nota' ? (
                        <Link
                          to={`/elections/lok-sabha-elections/${createSlug(
                            item?.sn,
                          )}/${createSlug(item?.cns_name)}/candidateshow/${
                            item?.seonm
                          }-${item.c_id}`}
                          target="_blank"
                        >
                          <CandidateCard
                            candidate={item}
                            index={idx}
                            isWapView={this.props.isWapView}
                          />
                        </Link>
                      ) : (
                        <CandidateCard
                          candidate={item}
                          index={idx}
                          isWapView={this.props.isWapView}
                        />
                      ),
                  )}
                </Slider>
              </div>
            )}
          {this.props.isWapView &&
            this.props.starCandidatesData &&
            !this.props.starCandidatePage &&
            Array.isArray(this.props.starCandidatesData) &&
            this.props.starCandidatesData.length > 0 && (
              <div className={s.scrollWrap}>
                {this.props.starCandidatesData.map(
                  (item, idx) =>
                    this.state.candidateLinking &&
                    item?.sn &&
                    item?.seonm &&
                    item?.cns_name &&
                    item.seonm !== 'nota' ? (
                      <Link
                        to={`/elections/lok-sabha-elections/${createSlug(
                          item.sn,
                        )}/${createSlug(item.cns_name)}/candidateshow/${
                          item.seonm
                        }-${item.c_id}`}
                        target="_blank"
                      >
                        <CandidateCard
                          candidate={item}
                          index={idx}
                          isWapView={this.props.isWapView}
                        />
                      </Link>
                    ) : (
                      <CandidateCard
                        candidate={item}
                        index={idx}
                        isWapView={this.props.isWapView}
                      />
                    ),
                )}
              </div>
            )}
          <div
            className={`${s.consTopHead} ${
              this.props.loksabha || this.props.isWapView ? s.cardiTopHead : ''
            } ${
              this.props.starCandidatesData &&
              Array.isArray(this.props.starCandidatesData) &&
              this.props.starCandidatesData.length <= 0
                ? s.starCandidate
                : ''
            }`}
          >
            <div className={s.searchBox}>
              <InputSearch
                placeholder={`Search Candidate Name / Party / Constituency ${
                  this.props.force ? '' : '/ State'
                }`}
                searchHandler={this.handleSearchChange}
              />
            </div>

            {this.props.loksabhaStates &&
              Array.isArray(this.props.loksabhaStates) && (
                <div className={s.sortSearchWrap}>
                  <SortSelect
                    options={this.props.loksabhaStates}
                    onSelect={this.handleStateChange}
                    selectedOption={this.state.currentState}
                  />
                </div>
              )}

            {(!this.props.isWapView || !this.props.loksabha) && (
              <div className={s.sortSearchWrap}>
                <SortSelect
                  options={this.state.selectedConst}
                  onSelect={this.handleConstChange}
                  selectedOption={this.state.currentConst}
                />
              </div>
            )}

            <div className={s.sortSearchWrap}>
              <SortSelect
                options={this.status}
                onSelect={this.handleWonLostChange}
                selectedOption={this.state.currentStatus}
              />
            </div>
          </div>
          {!this.props.starCandidatePage &&
            this.props.starCandidatesData &&
            Array.isArray(this.props.starCandidatesData) &&
            this.props.starCandidatesData.length > 0 && (
              <Listingheader headingname="All Candidates" />
            )}
          {!itemsToShow && (
            <div
              className={`${s.noDataBox} ${
                this.props.starCandidatesData &&
                Array.isArray(this.props.starCandidatesData) &&
                this.props.starCandidatesData.length === 0
                  ? s.topGap
                  : ''
              }`}
            >
              No candidates match your search criteria. Please search again!
            </div>
          )}
          <div
            className={`${s.candidateListWrap} ${
              this.props.starCandidatePage ? s.starCandidate : ''
            } ${
              this.props.starCandidatesData &&
              Array.isArray(this.props.starCandidatesData) &&
              this.props.starCandidatesData.length === 0
                ? s.topGap
                : ''
            }`}
          >
            {itemsToShow &&
              Array.isArray(itemsToShow) &&
              itemsToShow.length > 0 &&
              itemsToShow.map(
                (item, idx) =>
                  this.state.candidateLinking &&
                  item?.sn &&
                  item?.seonm &&
                  item?.cns_name &&
                  item.seonm !== 'nota' ? (
                    <Link
                      to={`/elections/lok-sabha-elections/${createSlug(
                        item.sn,
                      )}/${createSlug(item.cns_name)}/candidateshow/${
                        item.seonm
                      }-${item.c_id}`}
                      target="_blank"
                    >
                      <CandidateCard
                        candidate={item}
                        index={idx}
                        isWapView={this.props.isWapView}
                        isMiniCard={!this.props.starCandidatePage}
                      />
                    </Link>
                  ) : (
                    <CandidateCard
                      candidate={item}
                      index={idx}
                      isWapView={this.props.isWapView}
                      isMiniCard={!this.props.starCandidatePage}
                    />
                  ),
              )}
          </div>
        </div>
        {itemsToShow &&
          Array.isArray(itemsToShow) &&
          (itemsToShow.length >= itemsPerPage ||
            Math.ceil(this.props.filteredData.length / itemsPerPage) > 1) && (
            <PaginationWidgetWithoutLink
              totalStories={this.props.filteredData.length}
              storiesPerPage={itemsPerPage}
              currentPage={this.state.currentPage}
              onPageChange={this.handlePageChange}
              isMobile={this.props.isWapView}
            />
          )}
        {this.state.source && (
          <div className={`${s.source} ${s.cl}`}>
            Source: {this.state.source}
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxElectionData: (
    url,
    year,
    searches,
    sort,
    loader = false,
    force = false,
    starCandidatePage = false,
  ) => {
    dispatch(
      loadYearWiseCandidatesData(
        url,
        year,
        searches,
        sort,
        loader,
        force,
        starCandidatePage,
      ),
    );
  },
  filterData: (searches, sort, loader = false) => {
    dispatch(filterSearchSortData(searches, sort, loader));
  },
});

const mapStateToProps = state => ({
  filteredData: state.newslisting && state.newslisting.filteredData,
  starCandidatesData: state.newslisting && state.newslisting.starCandidatesData,
  loksabha: state.newslisting && state.newslisting.loksabha,
  stateConstMapping: state?.newslisting?.stateConstMapping,
  loksabhaStates: state?.newslisting?.loksabhaStates,
  dataLoading: state?.newslisting?.dataLoading,
  force: state.newslisting && state.newslisting.force,
});

ConstituencyCandidateWrapper.propTypes = {
  loksabha: PropTypes.bool,
  filteredData: PropTypes.objectOf({}),
  starCandidatesData: PropTypes.objectOf({}),
  stateConstMapping: PropTypes.objectOf({}),
  loksabhaStates: PropTypes.objectOf({}),
  dataLoading: PropTypes.bool,
  force: PropTypes.bool,
};
ConstituencyCandidateWrapper.defaultProps = {
  loksabha: false,
  filteredData: {},
  starCandidatesData: {},
  dataLoading: false,
  stateConstMapping: {},
  loksabhaStates: {},
  force: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(
  ConstituencyCandidateWrapper,
);
